import { render, staticRenderFns } from "./CardDownload.vue?vue&type=template&id=3220192e&scoped=true"
import script from "./CardDownload.vue?vue&type=script&lang=js"
export * from "./CardDownload.vue?vue&type=script&lang=js"
import style0 from "./CardDownload.vue?vue&type=style&index=0&id=3220192e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3220192e",
  null
  
)

export default component.exports